// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hg_ZUH4bk6UZ8hl15gw5{justify-content:space-between;align-items:center;display:flex}.ZQKi0X0kND8lkOC6Gzv7{color:var(--content-primary-primary);font-size:13px;font-weight:500}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wait": `hg_ZUH4bk6UZ8hl15gw5`,
	"wait__label": `ZQKi0X0kND8lkOC6Gzv7`,
	"waitLabel": `ZQKi0X0kND8lkOC6Gzv7`
};
export default ___CSS_LOADER_EXPORT___;
